import "./themes.css.ts.vanilla-4ed993c7.js";
const o = {
    sm: 544,
    md: 768,
    lg: 992,
    xl: 1440
  },
  a = Object.fromEntries(Object.entries(o).map(_ref => {
    let [e, s] = _ref;
    return [e, `screen and (min-width: ${s}px)`];
  })),
  m = Object.fromEntries(Object.entries(a).map(_ref2 => {
    let [e, s] = _ref2;
    return [e, {
      "@media": s
    }];
  })),
  d = _ref3 => {
    let {
      mobile: e,
      desktop: s
    } = _ref3;
    return {
      ...e,
      "@media": {
        [a.md]: s
      }
    };
  },
  r = (e, s) => e ? e + "." + s : s;
function c(e) {
  let s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return Object.entries(e).reduce((t, _ref4) => {
    let [b, n] = _ref4;
    return typeof n == "object" ? {
      ...t,
      ...c(n, r(s, b))
    } : {
      ...t,
      [r(s, b)]: n
    };
  }, {});
}
const u = e => e.filter(Boolean).join(" ");
var l = {
    sm: "nbbs0e0",
    md: "nbbs0e1",
    lg: "nbbs0e2"
  },
  j = {
    1: "nbbs0e4",
    2: "nbbs0e5",
    3: "nbbs0e6",
    4: "nbbs0e7",
    5: "nbbs0e8",
    6: "nbbs0e9",
    special: "nbbs0e3",
    eyebrow: "nbbs0ea"
  },
  p = {
    400: "nbbs0eb",
    500: "nbbs0ec",
    600: "nbbs0ed",
    700: "nbbs0ee"
  };
export { o as a, l as b, u as c, m as d, c as f, j as h, a as q, d as r, p as w };